import { useSyncExternalStore } from 'react';
import { Platform } from 'react-native';

/**
 * CORE-1435 — сколько места снизу экрана сейчас занимает баннер cookie.
 *
 * Баннер лежит поверх страницы (`position: fixed`), и на телефоне он закрывал
 * главную кнопку Live-страницы: тап по «Присоединиться» попадал в «Отклонить».
 * Экраны, у которых важное действие живёт внизу, добавляют себе этот отступ,
 * чтобы кнопку можно было докрутить выше баннера.
 *
 * Обычный модуль без провайдера: писатель один (сам баннер), читателей мало, и
 * заводить ради одного числа контекст в корне приложения незачем.
 */

let inset = 0;
const listeners = new Set<() => void>();

/** Баннер сообщает свою высоту на экране вместе с внешним отступом; 0 — баннера нет. */
export function setCookieBannerInset(px: number): void {
  // Дробные пиксели из onLayout округляем вверх: недобор оставил бы край кнопки
  // под баннером, а дрожание на доли пикселя не должно перерисовывать экраны.
  const next = Number.isFinite(px) && px > 0 ? Math.ceil(px) : 0;
  if (next === inset) return;
  inset = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function readInset(): number {
  return inset;
}

/** Нижний отступ под баннер cookie. На нативе баннера нет — всегда 0. */
export function useCookieBannerInset(): number {
  const value = useSyncExternalStore(subscribe, readInset, readInset);
  return Platform.OS === 'web' ? value : 0;
}
